import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=9b3c54c2&scoped=true"
import script from "./ConversationMessage.vue?vue&type=script&lang=js"
export * from "./ConversationMessage.vue?vue&type=script&lang=js"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&id=9b3c54c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3c54c2",
  null
  
)

export default component.exports